import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import "./viewAttachment.css";

export class ViewAttachment extends Component {
    constructor(props) {
        super(props);
        this.state = {
  
        };
    }
    render() {
        

        let imageExtensions = ['png', 'jpg', 'jpeg', 'svg'];
        return (
            <div className={this.props.viewAttachment ? "modal fade show" : "modal fade"} id="modalContainer">

                <div className="modal-dialog-centered modal-xl viewAttachmentDialog" style={{margin:'auto',display: 'flex',alignItems: 'center',height: '100%'}}>
                    <div className="modal-content viewAttachmentContent" style={{marginTop:'0'}}>
                        <div className="" style={{backgroundColor: '#ffffff !important',display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 20px', borderBottom: '1px solid #ccc'}}>
                            <div className="icon-container">
                                <FontAwesomeIcon icon={['fas', 'paperclip']} size="lg" color='#0465AC' style={{ fontSize: 20 }} />
                            </div>
                            <span style={{ textTransform: "capitalize", fontSize: 20 }}>Attachment</span>
                            <FontAwesomeIcon
                                icon={['fas', 'times']}
                                style={{ cursor: 'pointer' }}
                                size="lg"
                                color="#000000"
                                onClick={() => this.props.closeAttachment()} // Close the modal
                            />
                        </div>
                        <div className="modal-body viewAttachment-body mt-3">
                            {
                                imageExtensions.includes(this.props.attachmentFileExtension) ?
                                    <div>
                                        <img src={this.props.attachmentPath + '/' + this.props.attachmentFile} alt='attachmentimg' width='100%' height='100%' />
                                    </div>
                                    :
                                    <iframe title='attachmentPath' src={this.props.attachmentPath + '/' + this.props.attachmentFile} alt="attachment" width='100%' height='100%' />
                            }
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}

export default ViewAttachment
